/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListShadowMCPInventoryUsers } from "../funcs/accessListShadowMCPInventoryUsers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListShadowMCPInventoryUsersResult } from "../models/components/listshadowmcpinventoryusersresult.js";
import {
  ListShadowMCPInventoryUsersRequest,
  ListShadowMCPInventoryUsersSecurity,
} from "../models/operations/listshadowmcpinventoryusers.js";
import { unwrapAsync } from "../types/fp.js";
export type ShadowMCPInventoryUsersQueryData =
  ListShadowMCPInventoryUsersResult;

export function prefetchShadowMCPInventoryUsers(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListShadowMCPInventoryUsersRequest,
  security?: ListShadowMCPInventoryUsersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildShadowMCPInventoryUsersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildShadowMCPInventoryUsersQuery(
  client$: GramCore,
  request: ListShadowMCPInventoryUsersRequest,
  security?: ListShadowMCPInventoryUsersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ShadowMCPInventoryUsersQueryData>;
} {
  return {
    queryKey: queryKeyShadowMCPInventoryUsers({
      projectId: request.projectId,
      serverUrl: request.serverUrl,
      limit: request.limit,
      cursor: request.cursor,
      gramSession: request.gramSession,
    }),
    queryFn: async function shadowMCPInventoryUsersQueryFn(
      ctx,
    ): Promise<ShadowMCPInventoryUsersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListShadowMCPInventoryUsers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyShadowMCPInventoryUsers(
  parameters: {
    projectId: string;
    serverUrl: string;
    limit?: number | undefined;
    cursor?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listShadowMCPInventoryUsers", parameters];
}
